<template>
   <div
      :class="['class-card', card?.discipline?.slug ?? route.params.discipline]"
   >
      <nuxt-link
         :to="{
            name: 'class',
            params: { slug: card.slug },
         }"
      >
         <div class="content">
            <p class="label grey">Class</p>
            <h4 class="bold title">{{ card.title }}</h4>
            <p class="meta xsmall grey">
               {{ card.modules.length }}
               Teachable{{ card.modules == 1 ? "" : "s" }} |
               {{ card.mediaCount }} Media
            </p>
         </div>
         <div :class="['media', { 'has-image': card.image }]">
            <Image
               v-if="card.image"
               class="image"
               fit="cover"
               :image="card.image"
            />
            <DefaultIcon class="default-icon" v-else />
         </div>
      </nuxt-link>
      <!-- <pre>{{ card }}</pre> -->
   </div>
</template>

<script setup lang="ts">
import DefaultIcon from "~/assets/images/icons/class-default-icon.svg?component";
const route = useRoute();
const props = defineProps({
   card: { type: Object, required: true },
});
</script>

<style lang="scss">
@import "~/assets/scss/globals/class-card";
</style>
